'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

.controller('ArrivalLocationEquipmentController',
    ['$scope', '$stateParams', '$state', '$translate', 'topBar', 'selfAccessRequestService', 'selfAccessRequest', 'processStep', 'lookUps',
        function ($scope, $stateParams, $state, $translate, topBar, selfAccessRequestService, selfAccessRequest, processStep, lookUps) {

        // Init
        var floorsByEmpLocation = _.groupBy(lookUps.EmployeeLocationFloors, 'EmployeeLocation');
            $scope.locationFloors = floorsByEmpLocation[selfAccessRequest.Employee.EmployeeLocation];
            $scope.isUserOffsite = selfAccessRequest.LocationIsLocationOffsite;

        if (_.isUndefined($scope.selfAccessRequest.LocationEquipment)) $scope.selfAccessRequest.LocationEquipment = {};

        if (!_.isUndefined(selfAccessRequest.LocationEquipment.EmployeeLocationFloorID)) {
            $scope.selectedLocationFloor = _.find($scope.locationFloors, {
                EmployeeLocationFloorID: selfAccessRequest.LocationEquipment.EmployeeLocationFloorID
            });
        }

        $scope.selfAccessRequest = selfAccessRequest;
        $scope.currentUserId = selfAccessRequest.EmployeeID;
        $scope.processStep = processStep;
        $scope.officeAutoCompleted = false;

        // Load translation asynchronously to avoid race condition
        $translate('iam.selfAccessRequest.arrival.pageTitle').then(function(translation) {
            topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                   '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-pencil-square-o');
        });

        // Select Location Floor


        if (selfAccessRequest.Employee
            && selfAccessRequest.Employee.IamOffice
            && selfAccessRequest.LocationEquipment.LocationOffice == null) {


            var locationParts = selfAccessRequest.Employee.IamOffice.split("-");

            if (_.isUndefined(locationParts[0]) || _.isUndefined(locationParts[1])) {
                $scope.selfAccessRequest.LocationEquipment.LocationOffice = "";
                $scope.selectedLocationFloor = null;
                $scope.selfAccessRequest.LocationEquipment.LocationIsLocationOffsite = false;
            }
            else {

                var floorNumber = locationParts[0];
                $scope.selfAccessRequest.LocationEquipment.LocationOffice = locationParts[1];

                var floorPreFilled = _.filter($scope.locationFloors, { FloorNumber: floorNumber });

                $scope.selectedLocationFloor = floorPreFilled[0];
                $scope.selfAccessRequest.LocationEquipment.LocationIsLocationOffsite = false;

                $scope.officeAutoCompleted = true;
            }
        }

        $scope.selectLocationFloor = function (floor) {
            if ($scope.processStep.IsReadOnly) return;
            if ($scope.officeAutoCompleted) return;

            $scope.selectedLocationFloor = floor;
            $scope.selfAccessRequest.LocationEquipment.LocationIsLocationOffsite = false;
        };

        // Is Location Floor Selected?
        $scope.isLocationFloorSelected = function (floor) {
            if (!$scope.selectedLocationFloor) return false;

            return floor.EmployeeLocationFloorID === $scope.selectedLocationFloor.EmployeeLocationFloorID;
        }

        // Select Location Offsite
        $scope.selectLocationOffSite = function () {
            if ($scope.processStep.IsReadOnly) return;
            if ($scope.officeAutoCompleted) return;


            $scope.selfAccessRequest.LocationEquipment.LocationIsLocationOffsite = true;
            $scope.selectedLocationFloor = null;
        };

        // Show Office Location
        $scope.showOfficeLocation = function () {
            return !_.isUndefined($scope.selfAccessRequest.LocationEquipment.EmployeeLocationFloorID);
        };

        // Save Location Equipment
        $scope.saveLocationEquipment = function () {

            if ($scope.selectedLocationFloor) {

                $scope.selfAccessRequest.LocationEquipment.EmployeeLocationFloorID =
                    $scope.selectedLocationFloor.EmployeeLocationFloorID;

                $scope.selfAccessRequest.LocationEquipment.LocationFloor =
                    $scope.selectedLocationFloor.FloorPrefix;
            }

            selfAccessRequestService
                 .updateSelfAccessRequestLocationEquipement($stateParams.userAccessRequestId, $scope.selfAccessRequest)
                 .then(function () {

                     // Confirm Process Step Location
                     selfAccessRequestService
                            .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, 'LocationEquipment')
                            .then(function (selfAccessRequest) {
                                $state.go(selfAccessRequest.SelfRequestPageRoute, {}, {reload:true});
                            });
                 });
        }

        // Go back to home page
        $scope.goToArrival = function () {
            $state.go('selfAccessRequest', {
                userAccessRequestId: $stateParams.userAccessRequestId
            }, { reload: true });
        }

        // Reset Ownership
        $scope.resetOwnership = function () {
            selfAccessRequestService.cancelSelfAccessRequestOwnership($stateParams.userAccessRequestId)
                       .then(function (response) {
                           window.location = environment.iamUrl;
                       });
        }
}]);
